import { getEnabledElement } from "component/toolManager/enabledElements.js";
import CustomEvent from "core/customEvent/index";

/**
 * @public
 * @class PanTool
 * @memberof Tools
 *
 * @classdesc Tool for panning the image.
 * @extends Tools.Base.BaseTool
 */
export default class PanTool {
  onMouseDrag = evt => {
    const eventData = evt.detail;
    const { element } = eventData;

    let viewport = element.viewport;
    let viewportObject = eventData.viewportObject;

    const translation = this._getTranslation(eventData);

    this._applyTranslation(viewport, translation);
    viewportObject.setViewport(viewport);

    // Zoom 변경에 따른 이벤트 발생
    var elementStub = getEnabledElement(eventData.element.element);
    CustomEvent.triggerEvent(
      eventData.element.element,
      CustomEvent.EVENTS.PAN_ZOOM_CHANGED,
      elementStub
    );
  };

  _getTranslation(eventData) {
    const { element, image, deltaPoints } = eventData;
    let viewport = element.viewport;

    let widthScale = viewport.scale;
    let heightScale = viewport.scale;

    image.rowPixelSpacing = image.pixelSpacing[0];
    image.columnPixelSpacing = image.pixelSpacing[1];

    if (image.rowPixelSpacing < image.columnPixelSpacing) {
      widthScale *= image.columnPixelSpacing / image.rowPixelSpacing;
    } else if (image.columnPixelSpacing < image.rowPixelSpacing) {
      heightScale *= image.rowPixelSpacing / image.columnPixelSpacing;
    }

    return {
      x: deltaPoints.page.x / widthScale,
      y: deltaPoints.page.y / heightScale
    };
  }

  _applyTranslation(viewport, translation) {
    viewport.translation.x += translation.x;
    viewport.translation.y += translation.y;
  }
}
